const revenueByDept = (revenues: any) => {
  let bodTotal: number = 0;
  let worTotal: number = 0;
  let fl1Total: number = 0;
  let insTotal: number = 0;
  let braTotal: number = 0;
  let fl3Total: number = 0;
  let fl4Total: number = 0;
  let fl2Total: number = 0;

  revenues.forEach((revenue: any) => {
    if (revenue._id === "B") {
      bodTotal = revenue.net;
    }
    if (revenue._id === "W") {
      worTotal = revenue.net;
    }
    if (revenue._id === "R") {
      fl1Total = revenue.net;
    }
    if (revenue._id === "H") {
      insTotal = revenue.net;
    }
    if (revenue._id === "B") {
      braTotal = revenue.net;
    }
    if (revenue._id === "V") {
      fl3Total = revenue.net;
    }
    if (revenue._id === "S") {
      fl4Total = revenue.net;
    }
  });


  const data = [
    {
      id: "Body shop",
      label: "Body Shop",
      value: bodTotal,
      color: "hsl(280, 70%, 50%)",
    },
    {
      id: "Workshop",
      label: "Workshop",
      value: worTotal,
      color: "hsl(345, 70%, 50%)",
    },
    {
      id: "Fast Lane 1",
      label: "Fast Lane 1",
      value: fl1Total,
      color: "hsl(354, 70%, 50%)",
    },
    {
      id: "Fast Lane 2",
      label: "Fast Lane 2",
      value: fl2Total,
      color: "hsl(100, 70%, 50%)",
    },
    {
      id: "Fast Lane 3",
      label: "Fast Lane 3",
      value: fl3Total,
      color: "hsl(253, 70%, 50%)",
    },
    {
      id: "Fast Lane 4",
      label: "Fast Lane 4",
      value: fl4Total,
      color: "hsl(354, 70%, 50%)",
    },
  ];

  return data;
};

export default revenueByDept;
